// Team member data for About page
export const teamMembers = [
  {
    id: 1,
    name: 'Sir Krishnakant Tamakuwala',
    title: 'Senior Legal Advisor',
    baseExperience: 40,
    baseYear: 2021,
  },
  {
    id: 2,
    name: 'Ar. Abhishek Tamakuwala',
    title: 'Chief Architect',
    qualifications: 'B.Arch, M.Plan (Gold Medalist)',
    baseExperience: 10,
    baseYear: 2021,
  },
  {
    id: 3,
    name: 'Mrs. Shruti Tamakuwala',
    title: 'Interior Architect',
    qualifications: 'B.Arch, M.Plan',
    baseExperience: 8,
    baseYear: 2022,
  },
];
